// ¿Hay que devolver al Dashboard al usuario que abrió una sección? (Dashboard.tsx). Lote A, error real: al recargar la
// página o abrir con un enlace directo un módulo oculto (hiddenForClients), EMPRESA TEST y el superadmin volvían al
// Dashboard porque la regla corría antes de que cargara el perfil (sin empresa todavía, "no ve los ocultos"). Mientras el
// perfil y la empresa cargan no se decide nada; con los datos ya cargados, la regla es la de siempre.

export interface EntradaVisibilidad {
  /** El perfil y la empresa todavía se están cargando (CompanyContext.loading). */
  cargando: boolean;
  /** La sección abierta es un módulo oculto para clientes o la página de un ítem del Anexo 1. */
  oculto: boolean;
  esResultadosPsicosocial: boolean;
  esChecklist: boolean;
  hayPerfil: boolean;
  veOcultos: boolean;
  veResultadosPsicosocial: boolean;
  veChecklist: boolean;
}

export function debeVolverAlDashboard(e: EntradaVisibilidad): boolean {
  if (e.cargando) return false;
  if (e.oculto && !e.veOcultos) return true;
  if (e.esResultadosPsicosocial && e.hayPerfil && !e.veResultadosPsicosocial) return true;
  if (e.esChecklist && !e.veChecklist) return true;
  return false;
}

/** Clave de sessionStorage con la sección abierta: sobrevive a la recarga de la pestaña, no a otra pestaña ni a cerrar
 *  el navegador; se borra al cerrar sesión. */
export const CLAVE_SECCION = 'ss_seccion_activa';

/** Sección al montar el Dashboard: manda el salto puntual (ss_init_tab, p. ej. desde Precios); si no, la guardada antes
 *  de recargar, si es una sección conocida y no es solo de superadmin; si no, el Dashboard. Lo que el usuario no puede
 *  ver lo corrige debeVolverAlDashboard cuando termina de cargar el perfil. */
export function seccionInicial(salto: string | null, guardada: string | null, esValida: (id: string) => boolean): string {
  if (salto) return salto;
  if (guardada && esValida(guardada)) return guardada;
  return 'dashboard';
}
